module.exports = __webpack_public_path__ + "static/media/How-To-Scrap-Your-Car-For-Top-Cash-In-Sunshine-Coast-And-Get-Paid-Quickly.9ba57d37.jpg";